import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_sigmasix.png",
      alt: "Estratégias SigmaSix",
    },
    title: "Venha Operar com a SigmaSix",

    // String ou array de strings
    text: [
      "Fundada em 2023, a empresa conta com tecnologia de ponta para gerar os melhores resultados em operações robotizadas. Elimine totalmente os fatores que te prejudicam no mercado e deixe o robô trabalhar pra você.",
      "Nossa prioridade acima de tudo é a sua satisfação e rentabilidade.",
    ],
    // testimonial: {
    //   text: "Nas voláteis ondas do mercado, a adaptação estratégica é a chave para alcançar ganhos além da média, sem negligenciar a segurança e o controle de risco.",
    //   author: {
    //     name: "Rodrigo Moliterno, Head de Renda Variável Veedha Investimentos",
    //     // picture: "",
    //   },
    // },
  },

  strategies: {
    title: "Estratégias SigmaSix",
    heading: "As melhores estratégias ao seu alcance",
    subtitle: "Escolha a estratégia que melhor se enquadra no seu perfil",
  },

  cta: {
    title: "Então, vamos começar??",
    subtitle: "Ative agora mesmo a extensão SigmaSix",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A SigmaSix",
    col1: [
      "Fundada em 2023 por Alessandro Corrêa, a SigmaSix é uma empresa líder no desenvolvimento de robôs traders para o mercado financeiro. Nossa história é marcada pela busca incansável pela excelência, pela inovação e pelo compromisso inabalável com a satisfação do cliente.",
      "Na SigmaSix, acreditamos que a transparência é a base de qualquer relacionamento sólido. Por isso, nos dedicamos a fornecer serviços e produtos com total clareza e honestidade. Valorizamos a confiança que nossos clientes depositam em nós e trabalhamos duro para garantir que essa confiança seja recompensada com resultados tangíveis e positivos. ",
      "Nossa equipe é composta por profissionais altamente qualificados e apaixonados pelo que fazem. Estamos constantemente atualizados com as últimas tendências do mercado financeiro e investimos em pesquisa e desenvolvimento para garantir que nossos produtos estejam sempre na vanguarda da tecnologia.",
    ],
    col2: [
      "Nosso compromisso com a qualidade é inegociável. Cada robô trader desenvolvido pela SigmaSix passa por rigorosos testes e análises para garantir seu desempenho e eficácia. Nosso objetivo é oferecer soluções que não apenas atendam, mas excedam as expectativas de nossos clientes.",
      "Além disso, reconhecemos que cada investidor é único, com suas próprias necessidades e objetivos. Por isso, oferecemos soluções personalizadas e adaptadas às preferências e metas individuais de cada cliente. Nosso foco é sempre fornecer resultados tangíveis que ajudem nossos clientes a alcançar seus objetivos financeiros. ",
      "A SigmaSix é mais do que uma empresa de tecnologia financeira. Somos uma comunidade de investidores, inovadores e visionários, unidos por uma paixão compartilhada pelo sucesso financeiro. Estamos comprometidos em construir um futuro onde todos tenham acesso a ferramentas e recursos que os capacitem a alcançar a liberdade financeira. Junte-se a nós e descubra o que a SigmaSix pode fazer por você.",
    ],
  },

  stats: {
    title: "Alguns Números da SigmaSix",
    subtitle:
      "Profissionais com mais de 12 anos de experiência na construção de Robos Traders",
    data: [
      {
        value: "+8",
        description: "Anos em atividade",
      },
      {
        value: "+2k",
        description: "Clientes neste período",
      },
      {
        value: "+3k",
        description: "Ordens de mini índice executadas",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da SigmaSix?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.code,
        title: "Precisão e Eficiência",
        description:
          "Nossos robôs traders utilizam tecnologia de ponta para garantir operações precisas e estratégicas no mercado financeiro.",
      },
      {
        icon: iconsSet.editParams,
        title: "Personalização",
        description:
          "Oferecemos soluções adaptadas às necessidades e metas individuais de cada investidor, garantindo uma experiência personalizada.",
      },
      {
        icon: iconsSet.clipboard,
        title: "Transparência Total",
        description:
          "Comprometemo-nos com a transparência em todas as nossas operações, garantindo que nossos clientes tenham total clareza em seus investimentos.",
      },
      {
        icon: iconsSet.ranking,
        title: "Qualidade Garantida",
        description:
          "Nossa equipe experiente e dedicada trabalha para garantir um serviço de alta qualidade, respaldado por rigorosos testes e análises. ",
      },
      {
        icon: iconsSet.optimization,
        title: "Inovação Constante",
        description:
          "Estamos sempre em busca de novas tecnologias e tendências do mercado financeiro para melhorar e expandir nossas ofertas aos clientes.",
      },
      {
        icon: iconsSet.growth,
        title: "Resultados Consistentes",
        description:
          "Ao escolher os produtos da SigmaSix, os investidores podem esperar resultados consistentes e eficazes em suas atividades de investimento.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Automatizar as operações é um dos primeiros passos para conseguir melhor consistência de execução e de resultados de um sistema de operar.  O Cronos e o Fênix sao excelentes para esses conceitos",
      author: "Alexandre (Stormer)",
      job: "Trader Profissional",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Minha expe­riência com a SigmaSix tem sido excele­nte. Desde o prime­iro contato, fiquei impressionado com a dedicação e­ profissionalismo da equipe. Eles têm um amplo conhe­cimento sobre robôs e ofe­recem estratégias e­ficazes. O atendimento ao clie­nte é rápido, sempre prontos a e­sclarecer dúvidas e forne­cer suporte quando nece­ssário.",
      author: "Juliano Cardoso",
      job: "Médico Anestesista",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
